import script from "./CrudServicios.vue?vue&type=script&setup=true&lang=js"
export * from "./CrudServicios.vue?vue&type=script&setup=true&lang=js"

import "./CrudServicios.vue?vue&type=style&index=0&id=71e9d824&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-71e9d824"]])

export default __exports__